import { format, isValid, parse } from 'date-fns';

// Date-only columns (Postgres `date`, e.g. entities.created_on) arrive as
// "YYYY-MM-DD". `new Date("2026-10-14")` reads that as UTC midnight, which
// shows as the previous day anywhere west of UTC (FIG-324 live bug: Created On
// 13/10 in the list, 2026-10-14 in Edit). Parse it as a local calendar date.
export function parseDateOnly(value: string | null | undefined): Date | null {
  if (!value) return null;
  const date = parse(value.slice(0, 10), 'yyyy-MM-dd', new Date());
  return isValid(date) ? date : null;
}

/** Local calendar date for display and sorting. Invalid input stays invalid. */
export function calendarDate(value: string): Date {
  return parseDateOnly(value) ?? new Date(NaN);
}

/** "14 Oct 2026" (DD MMM YYYY), or the fallback when missing or invalid. */
export function formatDateOnly(value: string | null | undefined, fallback = '-'): string {
  const date = parseDateOnly(value);
  return date ? format(date, 'dd MMM yyyy') : fallback;
}
